import React from 'react';

const WooCommerceIcon = ({ style = {}, className = '' }) => {
  const defaultStyle = {
    width: '1.3em',
    height: '1.3em',
    verticalAlign: '-0.3em',
    display: 'inline-block',
    ...style
  };

  return (
    <img
      src="/images/WooCommerce.svg"
      alt="WooCommerce"
      style={defaultStyle}
      className={className}
    />
  );
};

export default WooCommerceIcon;

